import styled,{createGlobalStyle} from 'styled-components';
import Variables from '../../assets/styleVariables';
export const Box = styled.div`
  width: 100%;
  //height: 100vh;
  display: flex;
  justify-content: center; 
  align-items: center; 
  //position: fixed;
  flex-direction: column;
  overflow-y: auto;
`;

export const GlobalStyle = createGlobalStyle`
    body{
      background-color: ${Variables.colors.complementary};
    }
`;